var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8EDF1",
    d: "M11.208 3.294v.97c0 2.179-1.464 4.009-3.453 4.558-.243.069-.409.286-.409.537 0 .254.169.47.41.54 1.991.549 3.452 2.38 3.452 4.558V15.706l-3.94 1.788-5.476-1.788V14.457c0-2.176 1.465-4.006 3.453-4.558.244-.07.41-.286.41-.537 0-.251-.17-.47-.41-.537-1.992-.552-3.453-2.382-3.453-4.561v-.97l4.014-1.933 5.402 1.933z",
    transform: "translate(-523.000000, -4979.000000) translate(380.000000, 4560.000000) translate(16.000000, 384.000000) translate(116.000000, 28.000000) translate(11.000000, 7.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D4D9DC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.144 6.068c0 .251-.11.468-.273.537-1.325.552-2.302 2.382-2.302 4.558v1.249H0v-1.25c0-2.175 1.464-4.005 3.453-4.557.244-.07.409-.286.409-.537 0-.251-.169-.471-.41-.537C1.462 4.98 0 3.15 0 .971V0h1.57v.97c0 2.179.974 4.009 2.301 4.561.16.066.273.286.273.537zM5.554 6.065c0 .254.168.47.409.54 1.992.55 3.453 2.38 3.453 4.558v1.249h-1.57v-1.25c0-2.178-.974-4.008-2.302-4.557-.16-.07-.272-.286-.272-.54 0-.251.11-.468.272-.537C6.87 4.978 7.846 3.148 7.846.97V0h1.57v.97c0 2.179-1.464 4.009-3.453 4.558-.244.069-.41.286-.41.537z",
    transform: "translate(-523.000000, -4979.000000) translate(380.000000, 4560.000000) translate(16.000000, 384.000000) translate(116.000000, 28.000000) translate(11.000000, 7.000000) translate(1.792415, 3.293828)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C6A042",
    d: "M2.933 16.041c0-1.732 1.109-3.42 3.567-4.793 2.459 1.374 3.568 3.061 3.568 4.793l-.992.583-5.386-.039-.757-.544z",
    transform: "translate(-523.000000, -4979.000000) translate(380.000000, 4560.000000) translate(16.000000, 384.000000) translate(116.000000, 28.000000) translate(11.000000, 7.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1BF5E",
    d: "M4.587 16.041c0-1.732.595-3.42 1.913-4.793 1.319 1.374 1.913 3.061 1.913 4.793l-.532.583-2.888-.039-.406-.544z",
    transform: "translate(-523.000000, -4979.000000) translate(380.000000, 4560.000000) translate(16.000000, 384.000000) translate(116.000000, 28.000000) translate(11.000000, 7.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#31313D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H10.553V1.933H0zM0 14.345H10.553V16.626H0z",
    transform: "translate(-523.000000, -4979.000000) translate(380.000000, 4560.000000) translate(16.000000, 384.000000) translate(116.000000, 28.000000) translate(11.000000, 7.000000) translate(1.223988, 1.361395)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1D1D28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H2.36V1.933H0zM0 14.345H2.36V16.626H0z",
    transform: "translate(-523.000000, -4979.000000) translate(380.000000, 4560.000000) translate(16.000000, 384.000000) translate(116.000000, 28.000000) translate(11.000000, 7.000000) translate(1.223988, 1.361395)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#515B68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H13V2.027H0zM0 16.973H13V19H0z",
    transform: "translate(-523.000000, -4979.000000) translate(380.000000, 4560.000000) translate(16.000000, 384.000000) translate(116.000000, 28.000000) translate(11.000000, 7.000000)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3E4751"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H2.581V2.027H0zM0 16.973H2.581V19H0z",
    transform: "translate(-523.000000, -4979.000000) translate(380.000000, 4560.000000) translate(16.000000, 384.000000) translate(116.000000, 28.000000) translate(11.000000, 7.000000)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#7B8391"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H2.581V2.027H0zM0 16.973H2.581V19H0z",
    transform: "translate(-523.000000, -4979.000000) translate(380.000000, 4560.000000) translate(16.000000, 384.000000) translate(116.000000, 28.000000) translate(11.000000, 7.000000) translate(8.426015, 0.000000)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.cca678ac.svg";
export { ForwardRef as ReactComponent };